export default {
  claimForCredit: {
    collapseTitle: {
      baseTitle: '收到信用证信息',
      contractDetail: '合同信息',
    },
    btnList: {
      save: '保存',
      submit: '确认认领',
      add: '新增行',
      remove: '删除行',
    },
    msg: {
      saveSussess: '保存成功！',
      submitSusscess: '认领成功！',
      amountTip: '合计金额不能大于信用证金额！',
      notClaim: '未完成认领，请核对！',
    },
  },
};
